import { defineMessages } from 'react-intl';

export default defineMessages({
  mainTitle: {
    id: 'components.EstimatedTaxCalculator.text.title',
    description: 'Cart summary line title',
    defaultMessage: 'Estimated Taxes',
  },
  addZipCodeButtonAdd: {
    id: 'components.EstimatedTaxCalculator.button.add',
    description: 'Add zip code button text',
    defaultMessage: 'Enter zip code',
  },
  addZipCodeButtonHide: {
    id: 'components.EstimatedTaxCalculator.button.hide',
    description: 'Hide zip code button text',
    defaultMessage: 'Hide',
  },
  txtZipCodePlaceholder: {
    id: 'components.EstimatedTaxCalculator.txtZipCode.placeholder',
    description: 'Insert zip code form text input placeholder',
    defaultMessage: 'Enter zip code',
  },
  btnSubmitValue: {
    id: 'components.EstimatedTaxCalculator.btnSubmit.value',
    description: 'Text for submit button',
    defaultMessage: 'Apply',
  },
  zipCodeEmpty: {
    id: 'components.EstimatedTaxCalculator.error.zipCodeEmpty',
    description: 'The zip code input is empty',
    defaultMessage: 'Please enter a zip code',
  },
  serviceFailed: {
    id: 'components.EstimatedTaxCalculator.error.serviceFailed',
    description: 'Tax rate service failed to get taxes information',
    defaultMessage: 'Service failed getting taxes information. Please try again.',
  },
  taxesNotFound: {
    id: 'components.EstimatedTaxCalculator.error.taxesNotFound',
    description: 'Tax rates not found for the given zip code',
    defaultMessage: 'Sorry, your zip code is not valid',
  },
});
